export default "__VITE_ASSET__CSh_XOAl__"